module.exports = __webpack_public_path__ + "images/519d986f600100b55c46e0977c1e572d-dog_paw_green.png";